<template>
  <div class="content-block">
    <div class="edit-workplace">
      <div class="row">
        <div class="col-md-6">
          <template v-if="user && user.getOrgs().length">
            <div class="edit-workplace__section" v-for="(place, index) in user.getOrgs()" :key="place.index">
              <template v-if="isEditWorkplace(place.org_id)">
                <div class="edit-user-block">
                  <div class="edit-user-block__title">
                    {{ $t('labels.work_place') }} <span v-if="index > 0">{{ index + 1}}</span>
                  </div>
                  <div class="edit-user-block__data-row">
                    <div class="edit-user-block__data-row-label">
                      {{ $t('labels.place') }}
                    </div>
                    <div class="edit-user-block__data-row-value">
                      <dep-name :orgId="place.org_id" :showParent="true"></dep-name>
                    </div>
                  </div>
                  <div class="edit-user-block__data-row">
                    <div class="edit-user-block__data-row-label">
                      {{ $t('labels.position') }}
                    </div>
                    <div class="edit-user-block__data-row-value">
                      {{place.note || $t('labels.not_specified1')}}
                    </div>
                  </div>
                  <div class="edit-workplace__link-container">
                    <div class="edit-workplace__link" @click="editWorkplace(place.org_id)">
                      {{ $t('labels.change') }}
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="edit-workplace__form">
                  <div class="edit-workplace__title">
                    {{ $t('labels.work_place') }} <span v-if="index > 0">{{ index + 1}}</span>
                  </div>
                  <div class="edit-workplace__delete">
                    <span @click="removeWorkplace(index)">{{ $t('labels.delete_work_place') }}</span>
                  </div>
                  <div class="edit-workplace__org-title">
                    <dep-name :orgId="place.org_id" :showParent="true"></dep-name>
                  </div>
                  <div class="edit-workplace__item edit-workplace__item--workplace">
                    <el-input
                        v-bind:class="{ showLabel: workplaces[index].note }"
                        v-model="workplaces[index].note"
                        type="text"
                        :placeholder="$t('labels.position')">
                    <label slot="prefix">{{ $t('labels.position') }}</label>
                </el-input>
                  </div>
                  <div class="edit-workplace__buttons-container">
                    <el-button @click="setOrgs()" type="primary">{{ $t('labels.save') }}</el-button>
                    <el-button @click="editWorkplaceCanel(place.org_id), showCurrentData()">{{ $t('labels.cancel') }}</el-button>
                  </div>
                </div>
              </template>
            </div>
          </template>
          <template v-else>
            <div class="edit-user-block">
              <div class="edit-user-block__title">
                {{ $t('labels.work_place') }}
              </div>
              <div class="edit-user-block__no-data">
                {{ $t('labels.not_specified') }}
              </div>
            </div>
          </template>
          <div v-if="!collapseVisible.newWorkplace" class="edit-workplace__add">
            <span @click="collapseVisible.newWorkplace = true">{{ $t('labels.add_work_place') }}</span>
          </div>
          <div v-if="collapseVisible.newWorkplace" class="edit-workplace__section">
            <div class="edit-workplace__title newPlace">
              {{ $t('labels.add_work_place') }}
            </div>
            <div class="edit-workplace__tree edit-workplace__item el-input el-input--prefix"
                 v-bind:class="{ showLabel: newWorkplace.org_id || error.org.invalid, error: !newWorkplace.org_id && error.org.invalid }">
              <tree-select @checked="orgChecked"
                           @showPopover="getDepTree"
                           :placeholder="`${$t('labels.organization_structure')} *`"
                           :data="depTree"
                           nodeKey="id"
                           ref="workplaceTree">
              </tree-select>
              <span class="el-input__prefix">
                  <label v-if="!newWorkplace.org_id && error.org.invalid"
                         class="label-error">
                       {{ error.org.message }}
                  </label>
                  <label v-else>{{ $t('labels.organization_structure') }} *</label>
                </span>
            </div>
            <div class="edit-workplace__item">
              <el-input
                          v-bind:class="{ showLabel: newWorkplace.note }"
                        v-model="newWorkplace.note"
                        type="text"
                        :placeholder="$t('labels.position')">
                    <label slot="prefix">{{ $t('labels.position') }}</label>
              </el-input>
            </div>
            <div class="edit-workplace__buttons-container">
              <el-button @click="addWorkplace()" type="primary">{{ $t('labels.add') }}</el-button>
              <el-button @click="collapseVisible.newWorkplace = false">{{ $t('labels.cancel') }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="edit-roles">
      <div class="row">
        <div class="col-md-6">
          <div class="edit-user-block">
            <div class="edit-user-block__title">
              {{ $t('labels.permitted_actions') }}
            </div>
            <div v-if="!collapseVisible.roles">
              <template v-if="user && user.getRoles()">
                <roles-to-text :roles="user.getRoles()"></roles-to-text>
              </template>
              <template v-else>
                {{ $t('labels.not_specified2') }}
              </template>
            </div>
            <div v-if="!collapseVisible.roles" class="edit-user-block__collapse-link">
              <span @click="collapseVisible.roles = !collapseVisible.roles, showCurrentData()">
                    {{ $t('labels.change') }}
              </span>
            </div>
            <div v-if="collapseVisible.roles" class="edit-user-block__collapse-item">
              <roles-switcher v-model="roles"></roles-switcher>
              <el-button @click="setRoles" type="primary">{{ $t('labels.save') }}</el-button>
              <el-button @click="collapseVisible.roles = !collapseVisible.roles">{{ $t('labels.cancel') }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  // import admin from 'src/api/admin'
  import depName from 'src/components/Orgs/OrgName.vue'
  // import getSpecialtyList from 'src/services/specialtyList'
  // import getDepartmentList from '@/services/departmentList'
  // import getRoles from 'src/services/roles.js'
  import TreeSelect from 'src/components/TreeSelect/TreeSelect.vue'
  import postsInRow from '@/components/Users/PostsInRow.vue'
  import _ from 'lodash'
  import rolesSwitcher from 'src/components/Users/RolesSwitcher.vue'
  import RolesToText from '@/components/Users/RolesToText.vue'

  export default {
    props: ['user', 'profile'],
    components: {
      depName,
      TreeSelect,
      postsInRow,
      RolesToText,
      rolesSwitcher
    },
    data () {
      return {
        userData: {
          roles: ['']
        },
        workplaces: [],
        newWorkplace: {
          org_id: '',
          note: ''
        },
        depTree: [],
        queryPosts: [],
        editWorkplacesMode: false,
        editedWorkplaces: [],
        collapseVisible: {
          roles: false,
          newWorkplace: false
        },
        specialtyList: [],
        roles: [],
        statusList: [],
        error: {
          org: {
            invalid: false,
            message: ''
          },
          posts: {
            invalid: false,
            message: ''
          },
          roles: {
            invalid: false,
            message: ''
          },
          services: {
            invalid: false,
            message: ''
          }
        }
      }
    },
    methods: {
      isDoctor (workplace) {
        return workplace.roles.some(function (element) {
          return element === 'doctor' || element === 'admin'
        })
      },
      async getDepTree () {
        try {
          let list = await this.$store.dispatch('orgs/loadRawOrgList')
          let tree = this.$store.getters['orgs/getRawTree'](list)
          this.depTree = tree;
        } catch (error) {
          console.error('LOG: getDepList -> error', error)
        }
      },
      remotePosts (value) {
        if (value !== '') {
          this.queryPosts = this.postsList.filter(item => {
            return item.key.toLowerCase()
              .indexOf(value.toLowerCase()) > -1;
          });
        } else {
          this.queryPosts = []
        }
      },
      showCurrentData () {
        this.roles = this.user.getRoles();
        this.workplaces = this.user.getOrgs();
      },
      statusInText (status) {
        let name = statusList.getStatusName(status)
        return name;
      },
      async addWorkplace () {
        if (this.validateWorkplaces(this.newWorkplace)) {
          this.workplaces.push(this.newWorkplace);
          this.setOrgs()
        }
      },
      editWorkplace (id) {
        if (this.editedWorkplaces.indexOf(id) < 0) {
          this.editedWorkplaces.push(id)
        }
      },
      editWorkplaceCanel (id) {
        let orgIndex = this.editedWorkplaces.indexOf(id)
        if (orgIndex >= 0) {
          this.editedWorkplaces.splice(orgIndex, 1)
        }
      },
      isEditWorkplace (id) {
        if (this.editedWorkplaces.indexOf(id) < 0) {
          return true;
        } else {
          return false;
        }
      },
      orgChecked (data, checked) {
        this.newWorkplace.org_id = data.id
      },
      updateWorkplace (index) {
        let data = {
          user_id: this.user._id,
          org_id: this.workplaces[index].org_id,
          status: this.workplaces[index].status,
          roles: this.workplaces[index].roles,
          posts: this.workplaces[index].posts,
          public: this.workplaces[index].public,
          primary_serv_id: this.workplaces[index].primary_serv_id || undefined,
          secondary_serv_id: this.workplaces[index].secondary_serv_id || undefined
        }
        if (this.validateWorkplaces(data)) {
          /* admin.updateOrg(data).then(() => {
            this.$emit('updateData')
            this.editedWorkplaces = []
          }).catch(() => {
            this.$emit('updateFailed')
          }) */
        }
      },
      removeWorkplace (index) {
        this.$confirm(this.$t('labels.org_will_delete_from_users_work_places'), `${this.$t('labels.delete_work_place')}?`, {
          confirmButtonText: this.$t('labels.delete'),
          cancelButtonText: this.$t('labels.cancel'),
          customClass: 'delete-modal'
        }).then(() => {
          this.workplaces.splice(index, 1);
          this.setOrgs();
        }).catch(() => {
          this.$message({
            type: 'info',
            // @ts-ignore
            message: this.$t('employees.delete_canceled')
          });
        });
      },
      resetNewWorkplace () {
        this.newWorkplace = {
          org_id: '',
          status: 'active',
          roles: [],
          post: ''
        }
        this.$refs.workplaceTree.reset()
      },
      addroles () {
        this.userData.roles.push('')
      },
      deleteroles (index) {
        this.userData.roles.splice(index, 1);
      },
      async setRoles () {
        try {
          await this.$store.dispatch('users/setRoles', {user_id: this.user.getId(), roles: this.roles})
          this.collapseVisible.roles = false
          this.$emit('updateData')
        } catch (e) {
          this.$emit('updateFailed')
        }
      },
      async setOrgs () {
        try {
          await this.$store.dispatch('users/updateUser', {user_id: this.user.getId(), orgs: this.workplaces})
          this.collapseVisible.roles = false
          this.$emit('updateData')
          this.editedWorkplaces = []
          this.collapseVisible.newWorkplace = false
        } catch (e) {
          this.$emit('updateFailed')
        }
      },
      validateWorkplaces (place) {
        if (!place.org_id) {
          this.setError('org', this.$t('labels.required_field'))
        }


        if (!this.error.org.invalid) {
          return true
        } else {
          return false
        }
      },
      setError (key, message) {
        this.error[key].invalid = true;
        this.error[key].message = message;
      },
      resetError (keys) {
        if (keys) {
          let arr = keys.split(', ')
          for (let key of arr) {
            this.error[key].invalid = false;
            this.error[key].message = '';
          }
        } else {
          let error = this.error;

          for (let item in error) {
            this.error[item].invalid = false;
            this.error[item].mesage = '';
          }
        }
      }
    },
    computed: {
      postsList: self => []
    },
    async mounted () {
      // this.$store.dispatch('users/loadPosts', true)
      this.showCurrentData()
      this.getDepTree()
    },
    watch: {
      workplaces: {
        handler: function (val, oldVal) {
          this.resetError();
        },
        deep: true
      },
      newWorkplace: {
        handler: function (val, oldVal) {
          this.resetError();
        },
        deep: true
      },
      userData: {
        handler: function (val, oldVal) {
          this.resetError();
        },
        deep: true
      }
    }
  }
</script>
<style lang="scss">
  @import 'src/assets/sass/paper/variables';
  .edit-roles .roles-switcher {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .edit-workplace, .edit-roles {

    &__link {
      display: inline-block;
      margin-right: 10px;
      color: $link-color;
      cursor: pointer;
    }

    &__section {
      margin-bottom: 8px;
      border-bottom: 1px solid #dcdfe6;
    }

    &__section-error {
      color: #ff5151;
      font-weight: 700;
      font-size: 12px;
    }

    &__item {
      margin-bottom: 20px;

      &--workplace {
        .el-input__inner {
          padding-right: 15px;
        }
      }
    }

    &__buttons-container {
      margin-bottom: 30px;
    }

    &__tree {
      &.error {
        .tree-select__input {
          border-color: #ff5151;
        }
      }
    }
    .services-tree-select {
      margin-bottom: 20px;
    }

    &__title {
      font-size: 16px;
      font-weight: 700;
      color: #333333;

      &.newPlace {
        margin-bottom: 30px;
      }
    }

    &__org-title {
      margin-bottom: 30px;
    }

    &__user-status {
      margin-bottom: 20px;
      margin-top: 20px;

      span {
        border-radius: $global-radius;
        padding: 10px 15px;
        background: #FDF2E6;
        color: #DF8C2F;
      }

      &.active {
        span {
          background: #ECF7E5;
          color: #52B12D;
        }
      }
    }

    &__add {
      margin-bottom: 15px;
      color: #2196F3;
      cursor: pointer;

      &:hover {
        color: lighten(#2196F3, 15%);
      }
    }

    &__delete {
      margin-bottom: 15px;

      span {
        font-size: 12px;
        color: #2196F3;
        cursor: pointer;

        &:hover {
          color: lighten(#2196F3, 15%);
        }
      }
    }

    .el-input--prefix .el-input__inner {
      padding-left: 15px;
    }

    /* Label */
    .el-input__prefix {
      left: 5px;
      top: -18px;
      font-size: 12px;
      opacity: 0;
      visibility: hidden;

      label {
        white-space: nowrap;
      }
    }

    .el-input,
    .el-select,
    .el-textarea {
      &.showLabel {
        .el-input__prefix {
          animation-name: showLabel;
          animation-duration: 0.5s;
          animation-direction: normal;
          animation-fill-mode: forwards;
          animation-timing-function: cubic-bezier(0.77, 0, 0.175, 1);
        }
      }
    }

    @keyframes showLabel {
      0% {
        visibility: visible;
        opacity: 0;
        transform: translateX(50px)
      }
      100% {
        visibility: visible;
        opacity: 1;
        transform: translateX(0)
      }
    }

    /* Erors */
    .el-input,
    .el-select {
      &.error {

        .el-input__inner {
          border-color: #ff5151;
          position: static;
        }

        .label-error {
          color: #ff5151;
          white-space: nowrap;
        }
      }
    }

    .el-select {
      min-width: 280px;

      @media (max-width: $screen-sm) {
        min-width: auto;
        width: 100%;
      }
    }
  }
</style>
